$(document).ready(function() {
    if (_.isObject(Liferay) && Liferay.ThemeDisplay.isSignedIn()) {
        var authInfoElement = $(".auth-info");

        $(authInfoElement).append(
           '<li><a id="dLabel" data-target="#" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false">'
           + Liferay.ThemeDisplay.getUserName()
           + '<span class="caret"></span>'
           + '</a>'
           + '<ul class="dropdown-menu" aria-labelledby="dLabel">'
           + '<li><a href="/c/portal/logout">Odjava</a></li>'
           + '</ul></li>');

        $('#dLabel').dropdown()
    }
});

module.export = {};


//////////////////
// WEBPACK FOOTER
// ./src/modules/ActiveUserInfo/ActiveUserInfo.js
// module id = 19
// module chunks = 0